import { Component, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { ISTATACARD, GENERIC_ERROR, ADD_ON, BRAND_APPROVED_ERRORS, IS_CAMPAIGN } from 'src/app/config/app-settings.config';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { AddOnService } from 'src/app/services/add-on.service';
import { SharedServiceService } from 'src/app/services/shared-service.service';
import { IwService } from 'src/app/services/iw.service';
import { Router } from '@angular/router';
import { ThemeService } from 'src/app/services/theme.service';
declare var add_ons_cards: Function;
declare var _satellite: any;

@Component({
  selector: 'app-addon-card',
  templateUrl: './addon-card.component.html',
  styleUrls: ['./addon-card.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AddonCardComponent implements OnInit, AfterViewInit {
  illus: any;
  resetImg: any;
  TATACARD = ISTATACARD;
  firstPanelSelected: boolean;
  secondPanelSelected: boolean;
  addonForm: FormGroup;
  addonList = [];
  addonCount = ISTATACARD ? 4 : 2;
  firstPanel: boolean = true;
  secondPanle: boolean = false;
  disableForm = false;
  id = 1;
  appNumber: any;
  crossSellEroor: any;
  flags: any;
  fcnFamilyHealthFlag = new FormControl('1', [Validators.required]);
  fcnAccidentInsuranceFlag = new FormControl('1', [Validators.required]);
  formControlArray = [];
  addonRequestBody: any;
  addOnServiceError: any;
  addonNumber = 1;
  addonListFinal = [];
  addonFlag = true;
  formValueNullFlag = true;
  addonData: any
  addonArray = []
  appNum: any;
  tempArray: any[];
  eapplyFormPostQDELabel: any;
  ralationWithMeDropDownLadel: any;
  genderDropDownLadel: any;
  AddonDone: boolean = false;
  add_on: any;
  applicantName: any;
  applicantApplicationNumber: any;
  maxDate: any;
  addonNumberToDisplay: any = 1;
  getAddonCountDcr: any;
  disableAddonSubmit = 0;
  disableCrossSellSubmit: any;
  partnerCode: any = sessionStorage.getItem('partner-code');
  containerType: any = sessionStorage.getItem('container-type');
  
  constructor(
    private fb: FormBuilder, 
    private addonService: AddOnService, 
    public sharedService: SharedServiceService, 
    private iw: IwService, 
    private router: Router, 
    private themeService: ThemeService
    ) {
    this.partnerCode = this.themeService.partnerCode;
   }

  ngOnInit() {

    this.add_on = ADD_ON;
    this.illus = this.TATACARD ? '/tata-card-en/resources/img/eapply/add-on-illustration.svg' : '/sbi-card-en/resources/img/eapply/add-on-illustration.svg';
    this.resetImg = this.TATACARD ? '/tata-card-en/resources/img/eapply/reload.svg' : '/sbi-card-en/resources/img/eapply/reload.svg';
    this.createForm();
    this.eapplyFormPostQDELabel = this.iw.geteapplyFormPostQDEDCR();
    this.genderDropDownLadel = this.iw.getaddOnGenderDCR();
    this.getAddonCountDcr = this.iw.getcardTypeAddOnMappingDCR()
    this.ralationWithMeDropDownLadel = this.iw.getaddOnRelationshipDCR();
    this.addonForm.valueChanges.subscribe((obj) => {
      this.validateForm(obj);
    })
    this.createDynamicForm();
    if(this.sharedService.fromSwiftJourney) {
      this.applicantName = this.sharedService.trackApplicationResponse.data.applicantDetails.firstName;
      this.applicantApplicationNumber = this.sharedService.trackApplicationResponse.data.applicationNumber;
    }
    else {
      this.applicantName = this.sharedService.trackApplicationResponse.eapplyApplicantDetails.firstName;
      this.applicantApplicationNumber = this.sharedService.trackApplicationResponse.applicationNumber;
    }

    let date= new Date();
    date.setFullYear(date.getFullYear()-18);
    this.maxDate = date.toISOString().split('T')[0];
    this.setAddonCount();
    let channel: any;
    if (this.sharedService.trackApplicationResponse) {
      if(this.sharedService.fromSwiftJourney) {
        channel = this.sharedService.trackApplicationResponse.data.channelCode;        
      }
      else {
        channel = this.sharedService.trackApplicationResponse.channelCode;        
      }
    } else {
      channel = this.sharedService.qdeSubmitData && this.sharedService.qdeSubmitData.WSCallChannelCode ? this.sharedService.qdeSubmitData.WSCallChannelCode : null;
    }

    if(channel ==='EALB' || this.sharedService.paramschannel =='901' || sessionStorage.getItem('channelId')=='901'){
      window["digitalData"].page = { pageName: 'sbi-card:banca addon-crosssell:campaign', pageType: 'Banca' };
    } else if (IS_CAMPAIGN || sessionStorage.getItem('campaign')=='true') {
      window["digitalData"].page = { pageName: 'sbi-card:eapply addon-crosssell:campaign', pageType: 'Campaign' };
    } else if(this.sharedService.paramsshortCode || sessionStorage.getItem('sc')){
      window["digitalData"].page = { pageName: 'sbi-card:reapply addon-crosssell:reapply', pageType: 'reapply' };
    } else {
      window["digitalData"].page = { pageName: 'sbi-card:eapply addon-crosssell:eapplyform', pageType: 'Eapply' };
    }
  }

  ngAfterViewInit(){
    let channel: any;
    if (this.sharedService.trackApplicationResponse) {
      if(this.sharedService.fromSwiftJourney) {
        channel = this.sharedService.trackApplicationResponse.data.channelCode;        
      }
      else {
        channel = this.sharedService.trackApplicationResponse.channelCode;        
      }
    } else {
      channel = this.sharedService.qdeSubmitData && this.sharedService.qdeSubmitData.WSCallChannelCode ? this.sharedService.qdeSubmitData.WSCallChannelCode : null;
    }

    if(channel ==='EALB' || this.sharedService.paramschannel =='901' || sessionStorage.getItem('channelId')=='901'){
      window["digitalData"].page = { pageName: 'sbi-card:banca addon-crosssell:campaign', pageType: 'Banca' };
    } else if (IS_CAMPAIGN || sessionStorage.getItem('campaign')=='true') {
      window["digitalData"].page = { pageName: 'sbi-card:eapply addon-crosssell:campaign', pageType: 'Campaign' };
    } else if(this.sharedService.paramsshortCode || sessionStorage.getItem('sc')){
      window["digitalData"].page = { pageName: 'sbi-card:reapply addon-crosssell:reapply', pageType: 'reapply' };
    } else {
      window["digitalData"].page = { pageName: 'sbi-card:eapply addon-crosssell:eapplyform', pageType: 'Eapply' };
    }
  }
  setAddonCount() {
    this.getAddonCountDcr.forEach(element => {
      if (element.key_name == this.sharedService.sbic_card_Type) {
        this.addonCount = element.key_value;
      }
    });
  }

  createDynamicForm() {
    this.formControlArray.push(this.fcnFamilyHealthFlag);
    this.formControlArray.push(this.fcnAccidentInsuranceFlag);
  }

  createForm() {
    this.addonForm = this.fb.group({
      fcnFirstName: ["", [Validators.required,Validators.pattern("^[A-Za-z]+$")]],
      fcnGender: ["", Validators.required],
      fcnDob: ["", Validators.required],
      fcnRelationShip: ["", Validators.required],
      fcnIsStayWithPrimary: ["1"],
      fcnLastName: ["", [Validators.required ,Validators.pattern("^[A-Za-z]+$")]],
      fcnMiddleName: ["", Validators.pattern("^[A-Za-z]+$")]
    })
  }

  get f() {
    return this.addonForm.controls
  }

  validateForm(obj) {
    if (this.addonForm.invalid) {
      this.formValueNullFlag = true

      if (obj.fcnFirstName == null &&
        obj.fcnGender == null &&
        obj.fcnDob == null &&
        obj.fcnRelationShipe == null &&
        obj.fcnLastName == null) {
        if (this.addonList && this.addonList.length) {
          this.formValueNullFlag = false
        }
      }
    }
    else if (this.addonForm.valid) {
      this.formValueNullFlag = false
    }

  }

  firstPanelOpen() {
    this.firstPanelSelected = true
    this.secondPanelSelected = false
  }

  secondPanelOpen() {
    this.firstPanelSelected = false
    this.secondPanelSelected = true
  }

  firstPanelClose() {
    this.firstPanelSelected = false
  }

  secondPanelClose() {
    this.secondPanelSelected = false
  }

  addAddonToCard() {
    if (this.addonForm.invalid) {
      return;
    } else if ((this.addonList.length == (this.addonCount - 1))) {
      return;
    } else {
      let addonDetails = { id: this.id, value: this.addonForm.value };
      this.addonList.push(addonDetails)
      this.formValueNullFlag = false;
      this.addonNumberToDisplay = this.addonNumberToDisplay + 1
      this.id++;
    }

    this.addonForm.reset();
    this.f.fcnIsStayWithPrimary.setValue('1')
    Object.keys(this.f).forEach(key => {
      this.addonForm.get(key).markAsUntouched();
      this.addonForm.get(key).markAsPristine();
    });
  }

  skipAddon() {
    if(window['_satellite']){
      _satellite.track("skip_add_ons");
    }
    if (this.sharedService.navigateToCrossSell) {
      this.firstPanel = false
      this.secondPanle = true
    } else {
      this.router.navigate(['/', 'success'], { skipLocationChange: this.partnerCode && this.containerType?true:false });
      // this.router.navigate(['/', 'success']);
    }
  }

  removeAddon(addon) {
    if (this.addonList) {
      this.addonNumberToDisplay = this.addonNumberToDisplay - 1
      this.addonListFinal = [];
      this.addonList.forEach(element => {
        if (!(element.id === addon.id)) {
          this.addonListFinal.push(element);

        }
      });
      this.addonList = [];
      this.addonList = this.addonListFinal
      this.validateForm(this.addonForm);
    }
  }

  enrollForBenefits() {
    if(this.disableCrossSellSubmit){
      return;
    }
    if(window['_satellite']){
      _satellite.track("enroll");
    }
    if (this.sharedService.qdeSuccessResponse && this.sharedService.qdeSuccessResponse.applicationNumber) {
      this.appNumber = this.sharedService.qdeSuccessResponse.applicationNumber;
    } else if (this.sharedService.trackApplicationResponse) {
      if(this.sharedService.fromSwiftJourney) {
        this.appNumber = this.sharedService.trackApplicationResponse.data.applicationNumber;
      }
      else {
        this.appNumber = this.sharedService.trackApplicationResponse.applicationNumber;
      }
    }
    this.flags = {
      "familyHealthProtectorFlag": this.fcnFamilyHealthFlag.value ? 1 : 0,
      "sbigGroupPersonalAccidentInsuranceFlag": this.fcnAccidentInsuranceFlag.value ? 1 : 0,
      "applicationNumber": this.appNumber
    }
    console.log("Req for setCrossSellFlag ==> ", this.flags);
    this.addonService.setCrossSellFlag(this.flags).subscribe((response: any) => {
      const res = { ...response.body };
      if (res) {
        if (res && res.crossSellRsError && res.crossSellRsError.status && res.crossSellRsError.status.toLowerCase() == 'failure') {
          this.disableCrossSellSubmit = 0;
          this.crossSellEroor = GENERIC_ERROR
          window["digitalData"].error = { message: GENERIC_ERROR };
          if(window['_satellite']){
            _satellite.track('form_error');
          }  
        }
        else if (res.crossSellRsType && res.crossSellRsType.crossSellStatus.toLowerCase() == 'success') {
          this.disableCrossSellSubmit = 1;
          let accessToken: any;
          let expiryTime: any;
          if (response.headers && response.headers.get("access_token")) {
            accessToken = response.headers.get("access_token");
          }
          if (response.headers && response.headers.get("expiry_time")) {
            expiryTime = response.headers.get("expiry_time");
          }

          if (accessToken) {
            sessionStorage.setItem("s24_access_token", accessToken);
          }
          if (expiryTime) {
            sessionStorage.setItem("s24_expiry_time", expiryTime);
          }
          this.crossSellEroor = ''
          this.router.navigate(['/', 'success'], { skipLocationChange: this.partnerCode && this.containerType?true:false });
          // this.router.navigate(['/', 'success']);
        }
      }
    }, error => {
      this.disableCrossSellSubmit = 0;
      this.crossSellEroor = GENERIC_ERROR
      window["digitalData"].error = { message: GENERIC_ERROR };
      if(window['_satellite']){
        _satellite.track('form_error');
      }
    });
  }

  trimObject(object) {
    object = Object.assign({}, object);
    let keys = Object.keys(object);
    keys.forEach(element => {
      if (typeof object[element] == "string" && object[element]) {
        object[element] = object[element].trim();
      } else if (typeof object[element] == "object" && object[element] && element != 'addOnDateOfBirth') {
        object[element] = this.trimObject(object[element]);
      }
    });
    return object;
  }

  applyForAddon() {
    if(this.disableAddonSubmit){
      return;
    }
    let labelsDisplay: any;
    if (this.eapplyFormPostQDELabel && this.eapplyFormPostQDELabel.addBenefits_container && this.eapplyFormPostQDELabel.addBenefits_container.addOn_container) {
      if (this.eapplyFormPostQDELabel.addBenefits_container.addOn_container.firstName_container && this.eapplyFormPostQDELabel.addBenefits_container.addOn_container.firstName_container.firstName_label) {
        labelsDisplay = this.eapplyFormPostQDELabel.addBenefits_container.addOn_container.firstName_container.firstName_label
      } if (this.eapplyFormPostQDELabel.addBenefits_container.addOn_container.middleName_container && this.eapplyFormPostQDELabel.addBenefits_container.addOn_container.middleName_container.middleName_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormPostQDELabel.addBenefits_container.addOn_container.middleName_container.middleName_label
      } if (this.eapplyFormPostQDELabel.addBenefits_container.addOn_container.lastName_container && this.eapplyFormPostQDELabel.addBenefits_container.addOn_container.lastName_container.lastName_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormPostQDELabel.addBenefits_container.addOn_container.lastName_container.lastName_label
      } if (this.eapplyFormPostQDELabel.addBenefits_container.addOn_container.dob_container && this.eapplyFormPostQDELabel.addBenefits_container.addOn_container.dob_container.dob_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormPostQDELabel.addBenefits_container.addOn_container.dob_container.dob_label
      } if (this.eapplyFormPostQDELabel.addBenefits_container.addOn_container.gender_container && this.eapplyFormPostQDELabel.addBenefits_container.addOn_container.gender_container.gender_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormPostQDELabel.addBenefits_container.addOn_container.gender_container.gender_label
      } if (this.eapplyFormPostQDELabel.addBenefits_container.addOn_container.relation_container && this.eapplyFormPostQDELabel.addBenefits_container.addOn_container.relation_container.relation_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormPostQDELabel.addBenefits_container.addOn_container.relation_container.relation_label
      } if (this.eapplyFormPostQDELabel.addBenefits_container.addOn_container.stayWithHolder_Text) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormPostQDELabel.addBenefits_container.addOn_container.stayWithHolder_Text
      }
    }

    add_ons_cards(this.sharedService.cardName, 'Addon Details', labelsDisplay)
    this.addonNumber = 1;
    if (this.sharedService.qdeSuccessResponse && this.sharedService.qdeSuccessResponse.applicationNumber) {
      this.appNum = this.sharedService.qdeSuccessResponse.applicationNumber;

    } else if (this.sharedService.trackApplicationResponse) {
      if(this.sharedService.fromSwiftJourney) {
        this.appNum = this.sharedService.trackApplicationResponse.data.applicationNumber;
      }
      else {
        this.appNum = this.sharedService.trackApplicationResponse.applicationNumber;
      }
    }
    if (this.addonList) {
      this.addonList.forEach(element => {
        let dob: any = new Date(element.value.fcnDob);
        const d = dob.getDate();
        const m = dob.getMonth() + 1;
        const y = dob.getFullYear();
        dob = `${y}-${(m + "").length === 1 ? "0" + m : m}-${(d + "").length === 1 ? "0" + d : d}`;
        this.addonData = {
          "addOnSerialNum": this.addonNumber,
          "addOnRelationshipWithMe": element.value.fcnRelationShip,
          "addOnSalutation": element.value.fcnGender == 'M' ? 1 : 0,
          "addOnFirstName": element.value.fcnFirstName ? element.value.fcnFirstName.trim() : '',
          "addOnMiddleName": element.value.fcnMiddleName ? element.value.fcnMiddleName.trim() : '',
          "addOnSurname": element.value.fcnLastName ? element.value.fcnLastName.trim() : '',
          "addOnEmbossingName": element.value.fcnFirstName.replace(/\s/g, '') + ' ' + element.value.fcnLastName.replace(/\s/g, ''),
          "addOnDateOfBirth": dob,
          "addOnGender": element.value.fcnGender,
          "addOnStayWithPrimary": element.value.fcnIsStayWithPrimary,


        }
        this.addonNumber++;
        this.addonArray.push(this.addonData)
      })

    }
    if (this.addonForm.valid) {

      let dob: any = new Date(this.f.fcnDob.value);
      const d = dob.getDate();
      const m = dob.getMonth() + 1;
      const y = dob.getFullYear();
      dob = `${y}-${(m + "").length === 1 ? "0" + m : m}-${(d + "").length === 1 ? "0" + d : d}`;
      this.addonData = {
        "addOnSerialNum": this.addonNumber,
        "addOnRelationshipWithMe": this.f.fcnRelationShip.value,
        "addOnSalutation": this.f.fcnGender.value == 'M' ? 1 : 0,
        "addOnFirstName": this.f.fcnFirstName.value ? this.f.fcnFirstName.value.trim() : '',
        "addOnMiddleName": this.f.fcnMiddleName.value ? this.f.fcnMiddleName.value.trim() : '',
        "addOnSurname": this.f.fcnLastName.value ? this.f.fcnLastName.value.trim() : '',
        "addOnEmbossingName": this.f.fcnFirstName.value.replace(/\s/g, '') + ' ' + this.f.fcnLastName.value.replace(/\s/g, ''),
        "addOnDateOfBirth": dob,
        "addOnGender": this.f.fcnGender.value,
        "addOnStayWithPrimary": this.f.fcnIsStayWithPrimary.value,

      }
      this.tempArray = []
      this.tempArray = this.addonList.length ? this.addonArray : [];
      this.tempArray.push(this.addonData);
      this.addonArray = this.tempArray;
    }
    this.addonRequestBody = {
      "applicationNumber": this.appNum,
      "eapplyAddOnDetailList": this.addonArray
    };
    console.log("Req for addAddon ==> ", this.addonRequestBody);
    this.addonService.addAddon(this.addonRequestBody).subscribe((response: any) => {
      const res = { ...response.body };
      if (res) {
        if (res && res.status && res.status.toLowerCase() == 'failure' && res.errorMessage) {
          this.disableAddonSubmit = 0;
          if (res.errorCode && res.errorCode === '202') {
            // const message = BRAND_APPROVED_ERRORS.appProccessBySales24.replace(/<card type>/g, this.sharedService.sbic_card_Type);
            const message = BRAND_APPROVED_ERRORS.appProccessBySales24;
            this.addOnServiceError = message;
            window["digitalData"].error = { message: this.addOnServiceError };
            if(window['_satellite']){
              _satellite.track('form_error');
            }
          } else {
            this.addOnServiceError = GENERIC_ERROR
            window["digitalData"].error = { message: GENERIC_ERROR };
            if(window['_satellite']){
              _satellite.track('form_error');
            }
          }
        }
        else if (res && res.status && res.status.toLowerCase() == 'success') {
          this.disableAddonSubmit = 1;
          let accessToken: any;
          let expiryTime: any;
          if (response.headers && response.headers.get("access_token")) {
            accessToken = response.headers.get("access_token");
          }
          if (response.headers && response.headers.get("expiry_time")) {
            expiryTime = response.headers.get("expiry_time");
          }

          if (accessToken) {
            sessionStorage.setItem("s24_access_token", accessToken);
          }
          if (expiryTime) {
            sessionStorage.setItem("s24_expiry_time", expiryTime);
          }
          this.addOnServiceError = ''
          this.AddonDone = true;
          this.f.fcnIsStayWithPrimary.setValue('1')
          Object.keys(this.f).forEach(key => {
            this.addonForm.get(key).markAsUntouched();
            this.addonForm.get(key).markAsPristine();
          });
          this.firstPanel = false
          this.secondPanle = true;
          if (this.sharedService.navigateToCrossSell) {
            this.secondPanelOpen();
          } else {
            this.router.navigate(['/success'], { skipLocationChange: this.partnerCode && this.containerType?true:false });
            // this.router.navigate(['/success']);
          }
        }
      }
    }, error => {
      this.disableAddonSubmit = 0;
      this.addonArray = []
      this.addOnServiceError = GENERIC_ERROR;
      window["digitalData"].error = { message: GENERIC_ERROR };
      if(window['_satellite']){
        _satellite.track('form_error');
      }
    });
  }

  alphabetsOnly(event) {
    let regex = /[a-zA-Z ]/;
    if (event.key.match(regex)) {
      return true;
    } else {
      return false;
    }
  }

  ClearResponse() {

    Object.keys(this.f).forEach(key => {
      this.addonForm.get(key).markAsUntouched();
      this.addonForm.get(key).markAsPristine();
    });
    this.addonForm.reset();
    this.f.fcnIsStayWithPrimary.setValue('1')
  }

  skipCrossCell() {
    if(window['_satellite']){
      _satellite.track("skip_enroll");
    }
    //this.router.navigate(['/', 'success']);
    this.router.navigate(['/success'], { skipLocationChange: this.partnerCode && this.containerType?true:false });
    // this.router.navigate(['/', 'success']);
  }
}
